import http from '@/http'

const state = {
	userJSON: localStorage.getItem('user'),
	token: localStorage.getItem('token')
}

const getters = {
	isLogged: state => {
		return !!state.token
	},
	isAdmin: state => {
		const user = state.userJSON ? JSON.parse(state.userJSON) : null
		return user ? !!user.isAdmin : false
	},
	user: state => {
		const user = state.userJSON ? JSON.parse(state.userJSON) : null
		if (user) delete user.isAdmin
		return user || null
	}
}

const actions = {
	login({ commit }, user) {
		return http
			.post('login_check', user)
			.then(response => {
				if (response.status === 200) {
					const token = response.data.token
					const userJSON = JSON.stringify(response.data.user)
					localStorage.setItem('token', token)
					localStorage.setItem('user', userJSON)
					commit('LOGIN_SUCCESS', { token, userJSON })
				} else throw 'Nie można zalogować. Dokładny opis błędu: ' + JSON.stringify(response.data)
			})
			.catch(error => {
				if (!error || typeof error.status !== 'number')
					throw 'Aktualnie nie można się zalogować. Prosimy spróbować później.'
				switch (error.status) {
					case 401:
						throw 'Niepoprawne dane logowania.'
					case 403:
						throw 'Konto jest nieaktywne.'
				}
				// throw 'Nie można zalogować. Dokładny opis błędu: ' + error.data
				throw 'Nie można zalogować.'
			})
	},
	logout({ commit }) {
		return new Promise(resolve => {
			setTimeout(() => {
				commit('LOGOUT')
				localStorage.removeItem('token')
				localStorage.removeItem('user')
				resolve(true)
			}, 1000)
		})
	},
	setCurrentUser({ commit }, user) {
		commit('SET_CURRENT_USER', JSON.stringify(user))
	}
}

const mutations = {
	LOGOUT(state) {
		state.token = null
		state.userJSON = null
	},
	LOGIN_SUCCESS(state, { token, userJSON }) {
		state.userJSON = userJSON
		state.token = token
	},
	SET_CURRENT_USER(state, userJSON) {
		state.userJSON = userJSON
	}
}

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
}
